import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from "../apiBase";
import { ownerSecretHeader } from "../ownerSecret";

console.log("*** EditFuelArmPage loaded");

export const EditFuelArmPage = ({ wtbalToEdit, currentAircraft, setWtbalToEdit }) => {
  const navigate = useNavigate();
  const tail = currentAircraft?.tailNumber || "";

  // fuel rows all share the same fuel arm
  const [station] = useState(wtbalToEdit?.id || "Fuel");
  const [arm, setArm] = useState(String(wtbalToEdit?.Arm ?? ""));

    if (!tail) {
      alert("Missing aircraft tail.");
      return;
      }

  const editFuelArm = async () => {
    try {
      const updatedFuel = {
        id: "fuel",
        Arm: Number(arm)
      };

      console.log("EditFuelArmPage: PUT URL:", `${API_BASE}/api/wtbals?tail=${encodeURIComponent(tail)}`);
      console.log("EditFuelArmPage: PUT body:", updatedFuel);

      const response = await fetch(`${API_BASE}/api/wtbals?tail=${encodeURIComponent(tail)}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          ...ownerSecretHeader(tail),
        },
        body: JSON.stringify(updatedFuel),
      });

      const data = await response.text();
      console.log("EditFuelArmPage: PUT status:", response.status);
      console.log("EditFuelArmPage: PUT response:", data);

      if (!response.ok) {
        alert(`Failed to update fuel arm: ${response.status} ${data}`);
        return;
      }

      if (setWtbalToEdit) {
        setWtbalToEdit(null);
      }

      navigate("/wtbals");
    } catch (error) {
      console.error("EditFuelArmPage: update failed:", error);
      alert("Failed to update fuel arm.");
    }
  };

  return (
    <>
      <article className="App-article">
        <h2>Edit Fuel Arm</h2>

        <table id="edit-fuel-arm">
          <caption className='caption_text'>Edit Fuel Arm</caption>
          <thead>
            <tr>
              <th className='fuel-station_box'>Station</th>
              <th className='fuel-arm_box'>Arm (in)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className='fuel-station_box'>{station}</td>
              <td className='fuel-arm_box'>
                <input
                  type="text"
                  className="fuel-arm-input"
                  value={arm}
                  onChange={(e) => setArm(e.target.value)}
                />
              </td>
            </tr>
          </tbody>
        </table>

        <button
          type="button"
          onClick={editFuelArm}
          style={{
            marginTop: "14px",
            padding: "8px 14px",
            fontWeight: "600",
            cursor: "pointer"
          }}
        >
          Save
        </button>
      </article>
    </>
  );
};

export default EditFuelArmPage;